import { avatarColorOptions } from "../../ui/colors";
import { MessageGroupMember, MessageGroupSummary } from "../messageGroups.types";

export {
  getJobChatCompanyDisplayName as getGroupCompanyDisplayName,
  isEmployeeRole,
  maskJobChatSenderForEmployee as maskGroupSenderForEmployee,
} from "../../job-chats/utils/jobChatEmployeeDisplay.utils";

export const getAvatarColor = (name: string) => {
  const value = name.split("").reduce((total, character) => total + character.charCodeAt(0), 0);
  return avatarColorOptions[value % avatarColorOptions.length];
};

export const getMemberFullName = (member: Pick<MessageGroupMember, "firstName" | "lastName">) =>
  [member.firstName, member.lastName].filter(Boolean).join(" ").trim();

export const getMemberRoleLabel = (member: MessageGroupMember) => {
  const raw = member.roleName || member.role;
  if (!raw) return null;
  return raw.toLowerCase() === "business" ? "Owner" : raw;
};

export const getMemberKey = (member: Pick<MessageGroupMember, "type" | "uid">) => `${member.type}:${member.uid}`;

export const getGroupInitials = (name: string) =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0]?.toUpperCase())
    .join("") || "?";

export const buildMessageGroupSender = (
  companyId: number | string | null | undefined,
  { uid, workforces, currentRole }: { uid: string; workforces: any[]; currentRole: string },
) => {
  if (currentRole === "employee") {
    const workforceUid = workforces?.find((workforce) => Number(workforce.companyId) === Number(companyId))?.uid;
    return { uid: workforceUid, type: "workforce" };
  }
  return { uid, type: "user" };
};

export const isMentionedInMessage = (message: any, sender: { type?: string; uid?: string }) => {
  const mentions = Array.isArray(message?.mentions) ? message.mentions : [];
  return mentions.some((mention: any) => mention.type === sender?.type && mention.uid === sender?.uid);
};

export const resolveGroupChatName = (group: Pick<MessageGroupSummary, "name">) => group.name;
